module.exports = __webpack_public_path__ + "img/3.a52041d7.jpg";